import React from 'react'
import clients from '../../data/clients'

//import React, {useEffect} from 'react'
//import TagManager from 'react-gtm-module'

const Intro = () => {

//  useEffect(() => {
//    TagManager.initialize({ gtmId: 'GTM-PPS98NWB' })
//  }, [])
//
//  const handleButtonClick = () => {
//    TagManager.dataLayer({
//      dataLayer: {
//        event: 'quick_donation_button_click',
//        button_name: 'Intro Quick Donation',
//        category: 'User Actions',
//        action: 'Click',
//        label: 'Submit Quick Donation Button'
//      }
//    })
//  }

  return (
    <section id="top" className='h-100 flex jcc aic'>
      <div className="container bg-white brd-white p-5">
        <div className="row">
          <div className="col-lg-7 flex aic">
            <div className='my-3'>
              <h1 className='title-intro c-medium upp'>Consulting and<br />blockchain development<br />company</h1>
              <h1 className='stroke c-medium'>CrypCons</h1>
              <div className="s-10"></div>
            </div>
          </div>
          <nav className="col-lg-5 flex aic jcfe tr mobile-hidden">
            <div className='menu'>
              <a href='#services' className='mx-3 px-1 c-dark fw-500'>
                Services
              </a><br /><br />
              <a href='#testimonials' className='mx-3 px-1 c-dark fw-500'>
                Testimonials
              </a><br /><br />
              <a href='#technology' className='mx-3 px-1 c-dark fw-500'>
                TechStack
              </a><br /><br />
              <a href='#values' className='mx-3 px-1 c-dark fw-500'>
                Values
              </a><br /><br />
              <a href='#cooperation' className='mx-3 px-1 c-dark fw-500'>
                Partnership Oportunities
              </a><br /><br />
              <a href='#get-started' className='mx-3 px-1 c-dark fw-500'>
                Get Started
              </a><br /><br />
              <a href='#clients' className='mx-3 px-1 c-dark fw-500'>
                Our Clients
              </a>
            </div>
          </nav>
        </div>
        <div className="flex aic jcsb w-60 mobile-block">
          {clients.slice(0, 4).map((item) =>
            <img src={item.pic} alt={item.name} width={80} height={80} className="obfc greyscale" />
          )}
          <span className="px-2 title-sub c-dark val fw-500">100+</span>
          <a href="#clients" className='c-theme fw-600 upp val' style={{fontSize: 15, marginLeft: 24, width: 'auto', borderColor: '#C91111', padding: '0 20px'}}>Success Projects</a>
        </div>
      </div>
    </section>
  )
}

export { Intro }
